export default __webpack_public_path__ + "2ea6d97d2120d0a9f7f8b3476753b6d3.png";